export const categories = [
  {
    slug: "training-plan",
    name: "训练计划",
    description: "从零基础的入门训练到进阶分化训练，科学规划你的每一次训练",
    icon: "ri-heart-pulse-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20gym%20interior%20with%20barbell%20and%20weights%2C%20clean%20minimalist%20industrial%20style%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20motivational%20atmosphere%2C%20professional%20fitness%20environment%2C%20dark%20rubber%20flooring%2C%20organized%20equipment%20layout&width=800&height=500&seq=category-training-plan&orientation=landscape",
    count: 156,
  },
  {
    slug: "diet-plan",
    name: "饮食方案",
    description: "增肌减脂的饮食科学，从营养基础到实操方案全覆盖",
    icon: "ri-bowl-line",
    image: "https://readdy.ai/api/search-image?query=Healthy%20meal%20prep%20with%20lean%20protein%20chicken%20breast%20salmon%20quinoa%20and%20fresh%20vegetables%2C%20wooden%20table%20surface%2C%20warm%20natural%20light%2C%20clean%20food%20photography%20style%2C%20minimalist%20composition%2C%20professional%20culinary%20aesthetic&width=800&height=500&seq=category-diet-plan&orientation=landscape",
    count: 98,
  },
  {
    slug: "body-shaping",
    name: "体型塑造",
    description: "针对不同部位的精准雕刻训练，打造理想猛男体型",
    icon: "ri-run-line",
    image: "https://readdy.ai/api/search-image?query=Athletic%20male%20silhouette%20doing%20pull%20ups%20at%20outdoor%20fitness%20park%2C%20golden%20sunset%20light%2C%20muscular%20definition%20visible%2C%20inspirational%20fitness%20photography%2C%20warm%20tone%2C%20dramatic%20sky%20background&width=800&height=500&seq=category-body-shaping&orientation=landscape",
    count: 124,
  },
  {
    slug: "mental-toughness",
    name: "意志力突破",
    description: "突破心理极限，建立猛男心态，让坚持成为一种习惯",
    icon: "ri-fire-line",
    image: "https://readdy.ai/api/search-image?query=Man%20meditating%20at%20sunrise%20on%20mountain%20top%2C%20foggy%20landscape%20below%2C%20powerful%20silhouette%2C%20warm%20golden%20morning%20light%2C%20inspirational%20and%20serene%20atmosphere%2C%20cinematic%20photography%20style&width=800&height=500&seq=category-mental-toughness&orientation=landscape",
    count: 67,
  },
];